import React from 'react'
import ForgotPasswordPage from './ForgotPasswordPage'

export * from './ForgotPasswordPage'
export default React.memo(ForgotPasswordPage)
